export const UncheckIcon = ({ className }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4205_35643)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.7652 6.26517C10.9116 6.11872 10.9116 5.88128 10.7652 5.73483C10.6187 5.58839 10.3813 5.58839 10.2348 5.73483L8.5 7.46967L6.76517 5.73483C6.61872 5.58839 6.38128 5.58839 6.23483 5.73483C6.08839 5.88128 6.08839 6.11872 6.23483 6.26517L7.96967 8L6.23483 9.73483C6.08839 9.88128 6.08839 10.1187 6.23483 10.2652C6.38128 10.4116 6.61872 10.4116 6.76517 10.2652L8.5 8.53033L10.2348 10.2652C10.3813 10.4116 10.6187 10.4116 10.7652 10.2652C10.9116 10.1187 10.9116 9.88128 10.7652 9.73483L9.03033 8L10.7652 6.26517Z"
          fill="#6A6A6A"
        />
        <path
          d="M8.5 14C11.8137 14 14.5 11.3137 14.5 8C14.5 4.68629 11.8137 2 8.5 2C5.18629 2 2.5 4.68629 2.5 8C2.5 11.3137 5.18629 14 8.5 14Z"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4205_35643">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
